const gql = (template: TemplateStringsArray) => template.join('');

export const issueSearchStableQuery = gql`
  query IssueSearchStableQuery(
    $cloudId: ID!
    $jql: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    jira {
      issueSearchStable(
        cloudId: $cloudId
        issueSearchInput: { jql: $jql }
        first: $first
        last: $last
        after: $after
        before: $before
      ) {
        totalCount
        totalIssueSearchResultCount
        edges {
          node {
            id
            issueId
            key
            assigneeField {
              user {
                accountId
                picture
                name
              }
            }
            issueType {
              avatar {
                medium
              }
              name
            }
            summary
            status {
              name
              statusId
              statusCategory {
                statusCategoryId
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
